export const url = {
    host:'http://192.168.1.74:8000/',
    frontendUrl: '/'
 
}